export default __webpack_public_path__ + "static/media/img_selected-industry-advocacy.8d50af75.svg";